// Shared country dial-codes for international lead capture.
// Ordered for the markets that matter: India first, then NRI-heavy regions.

export const COUNTRY_CODES = [
  { iso: "IN", code: "91",  label: "India",          min: 10, max: 10 },
  { iso: "AE", code: "971", label: "UAE",            min: 8,  max: 9  },
  { iso: "US", code: "1",   label: "USA / Canada",   min: 10, max: 10 },
  { iso: "GB", code: "44",  label: "United Kingdom", min: 9,  max: 10 },
  { iso: "SG", code: "65",  label: "Singapore",      min: 8,  max: 8  },
  { iso: "AU", code: "61",  label: "Australia",      min: 9,  max: 9  },
  { iso: "SA", code: "966", label: "Saudi Arabia",   min: 8,  max: 9  },
  { iso: "QA", code: "974", label: "Qatar",          min: 8,  max: 8  },
  { iso: "KW", code: "965", label: "Kuwait",         min: 8,  max: 8  },
  { iso: "OM", code: "968", label: "Oman",           min: 8,  max: 8  },
  { iso: "BH", code: "973", label: "Bahrain",        min: 8,  max: 8  },
  { iso: "NZ", code: "64",  label: "New Zealand",    min: 8,  max: 10 },
  { iso: "DE", code: "49",  label: "Germany",        min: 9,  max: 11 },
  { iso: "XX", code: "",    label: "Other",          min: 6,  max: 14 },
];

export function getCountry(iso) {
  return COUNTRY_CODES.find((c) => c.iso === iso) || COUNTRY_CODES[0];
}

// Returns "" if valid, else an error message.
export function validatePhone(iso, raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "Mobile number is required";
  const c = getCountry(iso);
  if (c.min === c.max && digits.length !== c.min)
    return `Enter a valid ${c.min}-digit number`;
  if (digits.length < c.min || digits.length > c.max)
    return `Enter a valid number (${c.min}–${c.max} digits)`;
  return "";
}

// Phone string sent to the CRM. India stays a plain 10-digit number
// (current CRM behaviour); international numbers are prefixed with the
// dial code so the sales team can call back.
export function buildCrmPhone(iso, raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  const c = getCountry(iso);
  if (c.iso === "IN") return digits;
  return c.code ? `${c.code}${digits}` : digits;
}
